import request from '@/utils/request'

// 조회
export function getContractServiceConsignmentProcedure(params, isProgress) {
  return request({
    url: `/api/getContractServiceConsignmentProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 예시
export function getContractServiceConsignmentProcedureSample(isProgress) {
  return request({
    url: `/api/getContractServiceConsignmentProcedureSample`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' }
  })
}
// 저장
export function saveContractServiceConsignmentProcedure(params, isProgress) {
  return request({
    url: `/api/saveContractServiceConsignmentProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'saved' }
  })
}
// 삭제
export function deleteContractServiceConsignmentProcedure(params, isProgress) {
  return request({
    url: `/api/deleteContractServiceConsignmentProcedure`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isProgress, apitype: 'deleted' }
  })
}
// 출력
export function getContractServiceConsignmentProcedureReport (params, isProgress) {
  let responseType = "blob"
  return request({
    url: '/api/getContractServiceConsignmentProcedureReport',
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    responseType: responseType,
    Notify: { use: isProgress, apitype: 'searched' }
  })
}